// src/api/business/approveApi.js
import { getRequest, apiRequest, ApiError } from "../apiConfig";

function unwrapList(payload) {
  if (Array.isArray(payload)) return payload;
  if (Array.isArray(payload?.data)) return payload.data;
  if (Array.isArray(payload?.businesses)) return payload.businesses;
  if (Array.isArray(payload?.results)) return payload.results;
  return [];
}

function mapBusiness(b) {
  return {
    _id: b._id,
    id: b._id,
    businessName: b.business_name,
    branchName: b.branch_name,
    country: b.country,
    state: b.state,
    city: b.city,
    businessEntity: b.business_entity,
    registrationNumber: b.registration_number,
    businessCategory: b.business_category,
    contactPersonName: b.contact_person_name,
    email: b.contact_email,
    mobileNumber: b.contact_mobile,
    totalEmployees: b.total_employees,
    status: b.status,
    blacklisted: b.blacklisted,
    blacklistReason: b.blacklist_reason,
    createdAt: b.created_at,
    updatedAt: b.updated_at,
  };
}

async function callWithMethodFallback(endpoint, data, methods = ["PUT", "PATCH", "POST"]) {
  let lastErr = null;
  for (const method of methods) {
    try {
      return await apiRequest(endpoint, { method, data });
    } catch (e) {
      lastErr = e;
      const status = e instanceof ApiError ? e.status : e?.status;
      if (status !== 404 && status !== 405) throw e;
    }
  }
  throw lastErr;
}

export async function getPendingBusinesses() {
  const payload = await getRequest("/admin/businesses/pending");
  return unwrapList(payload).map(mapBusiness);
}

export async function testConnection() {
  return await getRequest("/admin/businesses");
}

export async function approveBusiness(businessId, formData) {
  const apiData = {
    business_name: formData.businessName,
    branch_name: formData.branchName,
    country: formData.country,
    state: formData.state,
    city: formData.city,
    business_entity: formData.businessEntity,
    registration_number: formData.registrationNumber,
    business_category: formData.businessCategory,
    contact_person_name: formData.contactPersonName,
    contact_email: formData.email,
    contact_mobile: formData.mobileNumber,
    total_employees: formData.totalEmployees,
    status: "approved",
  };

  return await callWithMethodFallback(`/admin/businesses/${businessId}/approve`, apiData);
}

export async function rejectBusiness(businessId, reason) {
  return await callWithMethodFallback(`/admin/businesses/${businessId}/reject`, { reason });
}
